module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.5 22h3V10h-3v12zm-2-6l-8 6V10l8 6z\"></path></svg>"